const actionTypes = {
    ENABLE_MODALS: 'ENABLE_MODALS',
    CURBSIDE_CONCIERGE_INFO_MODAL: 'CURBSIDE_CONCIERGE_INFO_MODAL'
};

module.exports = actionTypes;
